import { commentsData } from "@/mocks/homeData";

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-50 text-center mb-2">观众热评</h2>
        <p className="text-foreground-500 text-sm text-center mb-8 md:mb-10">来自真实用户的观影反馈</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {commentsData.map((comment) => (
            <article key={comment.name} className="bg-background-100 rounded-lg border border-background-200/50 p-4 md:p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.currentTarget.parentElement as HTMLElement).style.display = "none";
                    }}
                  />
                </div>
                <div>
                  <h3 className="text-foreground-200 text-sm font-medium">{comment.name}</h3>
                  <time className="text-foreground-600 text-xs" dateTime={comment.date}>{comment.date}</time>
                </div>
              </div>
              <p className="text-foreground-500 text-sm leading-relaxed mb-3">{comment.content}</p>
              <div className="flex items-center gap-1 text-xs">
                <span className={`w-4 h-4 flex items-center justify-center ${comment.liked ? "text-accent-500" : "text-foreground-600"}`}>
                  <i className={comment.liked ? "ri-heart-fill" : "ri-heart-line"}></i>
                </span>
                <span className="text-foreground-600">{comment.liked ? "已点赞" : "点赞"}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}